module.exports = __webpack_public_path__ + "img/github.d14f446c.svg";